var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showFilterPanel),expression:"!showFilterPanel"}],attrs:{"depressed":""},on:{"click":function($event){_vm.showFilterPanel = !_vm.showFilterPanel}}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("mdi-menu")]),_vm._v(_vm._s(_vm.$vuetify.breakpoint.mdAndDown ? '' : 'Vis filter')+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }